import { createTheme, GlobalStyles as GDSGlobalStyles } from '@bechtel/gds';
import React, { ReactElement } from 'react';
import { ThemeProvider } from 'styled-components';
import { appTheme as appThemes } from '~/app-theme';
import { ApplicationGlobalStyles } from '~/components/global-styles';
//import I18n from '~/components/i18n';

const defaultTheme = createTheme();
const appTheme = { ...defaultTheme, ...appThemes };

const customRender = (ui: ReactElement<any>) => {
  React.useLayoutEffect = React.useEffect;
  return (
    <>
      {/* <I18n language="english"> */}
      <ThemeProvider theme={appTheme}>
        <GDSGlobalStyles></GDSGlobalStyles>
        <ApplicationGlobalStyles></ApplicationGlobalStyles>
        {ui}
      </ThemeProvider>
      {/* </I18n> */}
    </>
  );
};

export { customRender as appRender };

/* Need to discuss about the placement of this file */
